import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Checkmark from 'dibs-vg/dist/react/checkmark';
import classNames from 'classnames';
import style from './HoldRequestInput-style.scss';

class HoldRequestInput extends Component {
    constructor() {
        super();
        this.onClick = this.onClick.bind(this);
    }
    onClick() {
        const { isHoldRequestChecked } = this.props;
        this.props.onClick(!isHoldRequestChecked);
    }
    render() {
        const { isHoldRequestChecked } = this.props;
        const checkboxClasses = classNames(style.checkbox, {
            [style.checked]: isHoldRequestChecked,
        });

        return (
            <div className={style.container}>
                <div className={checkboxClasses} onClick={this.onClick}>
                    {isHoldRequestChecked && <Checkmark className={style.icon} />}
                </div>
                <label className={style.label} onClick={this.onClick}>
                    Place item on hold (include for how long)
                </label>
            </div>
        );
    }
}

HoldRequestInput.propTypes = {
    isHoldRequestChecked: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
};

export default HoldRequestInput;



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/ContactDealer/HoldRequestInput.jsx